<template>
  <div>
    <div
      v-if="!showAllCenters"
      class="overflow-auto d-flex justify-content-between"
    >
      <button
        to="/region/centers"
        class="btn btn-grey mt-4 mb-2 mx-3 align-self-start"
        @click="backToAllCenters"
      >
        <i class="far fa-arrow-left" />
        <span>{{ trans("region.backToAllCenters") }}</span>
      </button>

      <div class="mt-4 mb-2 mx-3">
        <h3 v-if="selectedCenter" class="centerName">
          {{ selectedCenter.name }}
        </h3>
      </div>
    </div>

    <div v-if="showAllCenters" class="tab-content">
      <div class="text-right mb-4 mx-4">
        <router-link to="/region/centers/newCentre" class="btn btn-primary">
          <i class="far fa-plus" />
          <span>{{ trans("center.addNewCenter") }}</span>
        </router-link>
      </div>

      <div class="panel panel-default panel-fill">
        <div class="panel-body">
          <div class="filter-box mb-3">
            <centers-filter-form
              v-model="searchFields"
              :filters-base-url="regionAdminFiltersBaseUrl"
              @search="search"
            />
          </div>

          <centers-table
            :centers="centers"
            :loading="loading"
            :current-sort-by="searchFields.sort_by"
            :sort-order="searchFields.sort_order"
            @sort="sortBy"
            @open="openCenter"
          />

          <div class="row-fluid float-right">
            <DerPaginate
              v-model="meta.current_page"
              :page-count="meta.last_page"
              :show-go="true"
              @change="getCenters"
            />
          </div>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import DerPaginate from "../../design-system/DerPaginate.vue";
import CentersFilterForm from "../Admin/Centers/CentersFilterForm.vue";
import CentersTable from "../Admin/Centers/CentersTable.vue";
import { regionAdminCentersGet } from "../../store/core/regions";

const REGION_ADMIN_FILTERS_BASE_URL = "/api/internal/region-admin/filters";

export default {
  components: { DerPaginate, CentersFilterForm, CentersTable },
  data() {
    return {
      loading: false,
      centers: [],
      meta: {
        current_page: 1,
        last_page: 1,
      },
      regionAdminFiltersBaseUrl: REGION_ADMIN_FILTERS_BASE_URL,
      searchFields: {
        page: 1,
        name: null,
        hsa_id: null,
        product_id: null,
        feature_id: null,
        created_from: null,
        created_to: null,
        sort_by: "name",
        sort_order: "asc",
      },
    };
  },
  computed: {
    selectedCenter() {
      return this.centers.find(
        (c) => c.id === parseInt(this.$route.params.id ?? 0, 10),
      );
    },
    showAllCenters() {
      return this.$route.name === "RegionCenters";
    },
  },
  mounted() {
    this.getCenters();
  },
  methods: {
    getCenters(page = 1) {
      this.loading = true;
      this.searchFields.page = page;

      regionAdminCentersGet(this.searchFields)
        .then((data) => {
          this.centers = data.data;
          this.meta = data.meta;
          this.loading = false;
        })
        .catch((error) => {
          console.log("Get region centers error: ", error);
          this.loading = false;
        });
    },
    search() {
      this.getCenters(1);
    },
    openCenter(id) {
      this.$router.push({ path: `/region/centers/${id}` });
    },
    backToAllCenters() {
      this.$router.push({ path: `/region/centers` });
    },
    sortBy(column) {
      if (this.searchFields.sort_by === column) {
        this.searchFields.sort_order =
          this.searchFields.sort_order === "asc" ? "desc" : "asc";
      } else {
        this.searchFields.sort_by = column;
        this.searchFields.sort_order = "asc";
      }
      this.getCenters(1);
    },
  },
};
</script>

<style lang="scss" scoped>
@use "/resources/assets/sass/abstracts/variables";

.centerName {
  color: variables.$dermicusBlue;
}
</style>
